var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceThirdWrapper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 57,
    viewBox: "0 0 340 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.366631 4.43061C-0.717862 2.43165 0.729362 0 3.00355 0H336.922C339.196 0 340.644 2.43166 339.559 4.43061L327.277 27.0694C326.793 27.9617 326.793 29.0383 327.277 29.9306L339.559 52.5694C340.644 54.5683 339.196 57 336.922 57H3.00353C0.729341 57 -0.717861 54.5683 0.366632 52.5694L12.6489 29.9306C13.133 29.0383 13.133 27.9617 12.6489 27.0694L0.366631 4.43061Z",
    fill: "url(#paint0_linear_1055_92761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1055_92761",
    x1: -33.0371,
    y1: 28.5,
    x2: 374.963,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235628,
    stopColor: "#FFE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFE882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC982"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceThirdWrapper);
export default __webpack_public_path__ + "static/media/price_third_wrapper.5a4023c254f135c920bf78ebe64908a3.svg";
export { ForwardRef as ReactComponent };